import React from 'react';

import { Button } from '@ergeon/core-components';

import { TopPanelLinkProps } from './types';

const TopPanelLink: React.FC<TopPanelLinkProps> = ({ href, children, isActive = false }) => {
  return (
    <Button
      asAnchor
      flavor="regular"
      href={href}
      isActive={isActive}
      taste="boundless">
      {children}
    </Button>
  );
};

export default TopPanelLink;
